import { Component, inject } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { ArtisansDesignersCreatedAndSoldProductsComponent } from '@components/artisans-designers-created-and-sold-products/artisans-designers-created-and-sold-products.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-all-artisans-designers-created-products',
  imports: [
    LnPagesArmorComponent,
    LnArrowBackSvgIconComponent,
    ArtisansDesignersCreatedAndSoldProductsComponent,
    TranslocoPipe,
  ],
  templateUrl: './all-artisans-designers-created-products.component.html',
  styleUrl: './all-artisans-designers-created-products.component.css',
})
export class AllArtisansDesignersCreatedProductsComponent {
  private menuActions = inject(MenuActions);
  goHome() {
    this.menuActions.goHome();
  }
}
